import { render, staticRenderFns } from "./PopupPolicy.vue?vue&type=template&id=738790b1&"
import script from "./PopupPolicy.vue?vue&type=script&lang=js&"
export * from "./PopupPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports